import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../images/campus-page-title.png'
import _imports_1 from '../images/campus-reward-1.png'
import _imports_2 from '../images/campus-reward-2.png'
import _imports_3 from '../images/for-moment-text.png'


const _withScopeId = n => (_pushScopeId("data-v-2c08b53a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-Pretendar cola-color text-center" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "title-header",
      src: _imports_0,
      alt: "모두의 챌린지 로고"
    })
  ]),
  /*#__PURE__*/_createElementVNode("h2", { class: "mt-5 text-14 fw-bold text-50" }, [
    /*#__PURE__*/_createTextVNode(" 캠퍼스 챌린지는 대학생들이 "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 함께 참여 할 수 있는 도전입니다. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 친구들과 팀을 이루어 투명 음료 페트병을 모으고 "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 지속 가능한 캠퍼스 문화를 만들어 가요! ")
  ])
], -1))
const _hoisted_2 = {
  class: "container",
  style: {"padding-bottom":"7.5rem"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pt-5 mt-5 d-none d-sm-block" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pt-5 mt-5" }, null, -1))
const _hoisted_5 = { class: "font-Pretendar cola-color text-center" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<img src=\"" + _imports_1 + "\" class=\"img-sx\" data-v-2c08b53a><div class=\"cola-color text-start img-sx mx-auto pt-sm-4 pt-1\" data-v-2c08b53a><ul data-v-2c08b53a><li class=\"text-8 text-24\" data-v-2c08b53a> 코카-콜라 제로 500ml 패키지 일부에는 재생원료가 사용되었습니다. </li><li class=\"text-8 text-24\" data-v-2c08b53a> 코카-콜라 제로 500ml는 가입 시 기입한 휴대전화 번호를 통해 전국 GS25 편의점에서 사용 가능한 모바일 교환권으로 제공됩니다. </li></ul></div><div class=\"pt-5 mt-5 d-none d-sm-block\" data-v-2c08b53a></div><div class=\"pt-5 mt-sm-5\" data-v-2c08b53a></div><img src=\"" + _imports_2 + "\" class=\"img-sx\" data-v-2c08b53a>", 5)
const _hoisted_11 = { class: "d-flex justify-content-center text-start" }
const _hoisted_12 = { class: "font-Pretendar img-sx" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "ms-3 mt-5 img-wtitle"
}, null, -1))
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"d-none d-sm-block\" data-v-2c08b53a><svg width=\"30\" height=\"54\" viewBox=\"0 0 49 54\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-2c08b53a><path d=\"M23.5723 15.2425C23.8084 7.95806 25.679 1.46654 26.4129 1.50675C27.1772 1.54803 27.9316 8.76514 28.1075 14.4357C28.2526 19.1457 27.9764 21.8942 29.8238 23.2612C31.0876 24.1935 32.3854 23.7775 35.0637 23.6531C41.1909 23.3687 47.3646 24.9707 47.4052 26.0311C47.4425 27.0582 41.8191 28.6974 36.4529 28.9898C32.6176 29.198 31.4882 28.5772 30.1836 29.618C28.1915 31.2093 29.0044 34.1226 28.7124 40.7541C28.5271 44.9942 27.8306 52.0857 26.8153 52.1432C25.8782 52.1954 24.1265 46.2559 23.8421 40.1287C23.5815 34.5215 24.7136 32.4219 23.0881 30.7129C21.5932 29.1386 19.59 29.8257 13.3465 29.6173C8.54584 29.4607 1.71981 28.787 1.67996 27.9077C1.63596 27.0445 8.08798 25.4821 13.9659 24.8428C18.7987 24.3164 20.8539 24.6721 22.3983 22.9834C23.9099 21.3357 23.4406 19.3617 23.5751 15.2381L23.5723 15.2425Z\" fill=\"#FFF681\" stroke=\"#F40000\" stroke-width=\"2.09011\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-2c08b53a></path></svg></div><div class=\"d-block d-sm-none d-flex flex-column justify-content-center\" data-v-2c08b53a><svg width=\"14\" height=\"14\" viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-2c08b53a><path d=\"M6.67093 3.88927C6.73211 2.00199 7.21675 0.320127 7.40689 0.330545C7.60491 0.341241 7.80037 2.21109 7.84594 3.68025C7.88354 4.90054 7.81198 5.61263 8.29062 5.96682C8.61803 6.20836 8.95429 6.10057 9.6482 6.06834C11.2357 5.99465 12.8352 6.40972 12.8457 6.68446C12.8554 6.95057 11.3984 7.37524 10.0081 7.45099C9.01444 7.50495 8.72182 7.3441 8.38382 7.61376C7.86772 8.02606 8.07831 8.78084 8.00266 10.499C7.95465 11.5975 7.77419 13.4348 7.51115 13.4497C7.26837 13.4632 6.81453 11.9244 6.74084 10.3369C6.67333 8.88419 6.96663 8.34022 6.54548 7.89745C6.15818 7.48955 5.63918 7.66757 4.02159 7.61358C2.7778 7.573 1.00927 7.39846 0.998949 7.17066C0.987549 6.947 2.65917 6.54221 4.18205 6.37657C5.43417 6.24019 5.96664 6.33236 6.36678 5.89484C6.75841 5.46794 6.63681 4.9565 6.67167 3.88814L6.67093 3.88927Z\" fill=\"#FFF681\" stroke=\"#F40000\" stroke-width=\"0.541517\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-2c08b53a></path></svg></div>", 2)
const _hoisted_16 = { class: "d-flex align-items-center text-10 text-38 text-start lh-sm" }
const _hoisted_17 = { class: "step-apply-collection" }
const _hoisted_18 = { class: "container" }
const _hoisted_19 = { class: "qna-wrapper" }
const _hoisted_20 = { class: "container" }

import BoxMoving from '@/templates/campaign-cocacola-season-6/components/box-moving.vue';
import DividedBoxRow from '@/templates/campaign-cocacola-season-6/components/divided-box-row.vue';
import HeadingBox from '../components/heading-box.vue';
import StepApplyCollection from '@/templates/campaign-cocacola-season-6/components/step-apply-collection.vue';
import QuestionAnswerSs6 from '@/templates/campaign-cocacola-season-6/components/question-answer-ss6.vue';
import ChallengeList from '../components/challenge-list.vue';
import type { Challenge } from './model/challenge';
import { request } from '@/utils';
import { onMounted, ref } from 'vue';
import { authStore } from '@/stores';

interface Props {
  challenges: Challenge[];
}


export default /*#__PURE__*/_defineComponent({
  props: {
    challenges: null
  },
  emits: ['show-error'],
  setup(__props: any, { emit }) {




const handleShowError = (message: string) => {
  emit('show-error', message);
};




const isParticipated = async (everyone_prog_id: Number) => {
  try {
    const records = await request.get('user_requests', {
      params: {
        target_id_eq: everyone_prog_id,
        target_type_eq: 'Program',
        type_eq: 'ParticipationRequest'
      }
    });
    return records.data && records.data.length > 0 && records.data.find((r: any) => r.original_state === 'approved');
  } catch (error) {
    return false;
  }
};
const participate = ref(false);

//mounted
onMounted(async () => {
  if (authStore.isLogin) {
    participate.value = await isParticipated(198 as number);
  }
});

const stepApplySteps = [
  {
    number: 1,
    title: '투명 음료 페트병 채우기',
    subtitle: '제로 웨이스트 박스에 투명 음료 <br> 페트병을 가득 채워주세요.',
    image: require('../images/step-img-1b.png'),
    alt: '비닐과 페트병'
  },
  {
    number: 2,
    title: 'GS25 반값택배<br> 이용 방법',
    subtitle: '가볍게 <br>' +
        '밀봉해주세요.',
    image: require('../images/step-img-2b.png'),
    alt: '박스 테이핑'
  },
  {
    number: 3,
    title: ' GS25 반값\n' +
      '택배 예약하기',
    subtitle: '박스 상단 QR코드 스캔 <br>' +
        'or 캠페인 페이지 접속 후 <br>' +
        '반값택배 예약합니다.',
    image: require('../images/step-img-3b.png'),
    alt: 'QR코드 스캔'
  },
  {
    number: 4,
    title: 'GS25 방문하기',
    subtitle: 'GS25 점포 방문하여 <br>' +
        '수거신청을 합니다.',
    image: require('../images/step-img-4b.png'),
    alt: '박스 배치'
  }
];

const questionTabs = [
  {
    id: 'general',
    title: '지원하기',
    questions: [
      {
        id: 'q1',
        question: '캠퍼스 챌린지에 참여하려면 어떻게 해야 하나요? ',
        answer: '이번 시즌 6에서는 처음으로 캠퍼스 챌린지가 시작됐어요 (짝짝짝!)\n' +
          '캠퍼스 챌린지에 참여하려면 먼저 참여 대상 캠퍼스인지 확인하는 것이 중요해요.\n' +
          '우리 학교가 참여 캠퍼스인지 확인하고 싶으시다면 카카오채널에서 <원더플 캠페인>을 검색해 문의를 남겨주세요.\n'
      },
      {
        id: 'q2',
        question: '학교에서 캠퍼스 챌린지 홍보나 안내를 받지 못했어요. 어떻게 해야 하나요?',
        answer: '카카오채널에서 <원더플 캠페인>을 검색해 문의를 남겨 주시면 참여 학교가 맞는지 확인 후 어디에서 안내를 받으실 수 있는지 안내드릴 수 있어요.'
      }
    ]
  },
  {
    id: 'collection-request',
    title: '수거 신청',
    questions: [
      {
        id: 'q3',
        question: '페트병 뚜껑을 꼭 닫아야 하나요?',
        answer: '현재 환경부에서는 페트병을 압착 후, 공기가 다시 들어가지 않게끔 병뚜껑을 꼭 닫아서 분리배출하는 것을 권하고 있습니다. 그 이유는, 뚜껑을 닫은 상태여도 재활용에는 문제가 없고, 가능한 많은 양의 페트병을 한 번에 잘 모아서 수거가 되는 것이 중요하기 때문인데요. 원더플 캠페인에서도 박스의 크기가 한정된 만큼, 페트병은 깨끗하게 헹구고 잘 말린 다음 압착 후 뚜껑을 닫아서 가능한 많이 모아 주시면 됩니다. \n'
      },
      {
        id: 'q4',
        question: '추가 박스를 받고 싶어요! 어떻게 해야 하나요?',
        answer: '추가 박스가 더 필요할 경우 테라사이클 홈페이지를 통해 최대 5회까지 박스 추가 신청이 가능합니다.\n' +
          '추가로 받으신 박스 수량도 모두 소진될 시, 기존 받은 박스에 페트병을 압착해서 담아 보내는 방법을 이용해 주세요! 📦'
      },
      {
        id: 'q5',
        question: 'GS25 편의점 택배 이용 방법이 궁금해요',
        answer: 'STEP 1) 온라인 수거 신청\n' +
          '(1) 캠페인 페이지 내에서 수거 신청 버튼을 클릭 후 정보를 기입해 주시면 (2) 반값택배 예약 번호를 카카오 알림톡으로 받으실 수 있습니다. (3) 선택하신 편의점 위치를 확인 후, 제로 웨이스트 박스를 밀봉하여 GS25 편의점에 방문해 주세요. \n' +
          'STEP 2) GS25 편의점 반값택배 이용방법\n' +
                      'GS25 편의점 내 포스트박스 기계에서 \'예약 접수\' 버튼을 눌러주세요.\n' +
          '예약번호 12자리를 입력 후 예약 내역을 확인해 주세요\n' +
          '출력된 운송장을 박스 상단에 부착해주시고, 접수고객 보관용 QR코드는 반드시 계산대 점원에게 보여주셔야 한다는 점 꼭 기억하세요! '
      },
    ]
  },
  {
    id: 'rewards',
    title: '리워드/배송',
    questions: [
      {
        id: 'q7',
        question: '원더플 트럭이 무엇인가요?\n',
        answer: '원더플 캠퍼스 챌린지에 참여한 학교 중 수거량 상위 5개 학교를 대상으로 짜릿한 코카-콜라 음료가 실린 원더플 트럭이 찾아가요! 보틀투보틀에 참여해 주신 여러분들을 위해 특별한 원더플 트럭을 준비하고 있으니 기대해 주세요.'
      },
      {
        id: 'q8',
        question: '상위 5개 학교는 어떻게 선정이 되나요? \n',
        answer: '별도 안내 드린 오픈채팅방을 통해서 매주 업데이트되니 꼭 확인해주세요! \n' +
          '순위 선정 기준은 수거된 PET 무게 기준이에요. (한 박스에 투명 페트병을 많이 담을수록 유리하답니다)'
      },
      {
        id: 'q9',
        question: '리워드를 별도 구매할 수 있나요?\n',
        answer: '리워드는 캠페인에 참여해 주신 원더플 피플에게 감사의 의미로 제공되는 만큼 별도로 판매하지 않아요.'
      }
    ]
  }
];

const colaItems = [
  '정해진 기간 내에 제로 웨이스트 박스 전부 수거 신청해야 리워드를 받을 수 있어요.',
  '올바른 분리배출 방법을 지키지 않거나 투명 음료 페트병이 아닌 품목을 보내면 리워드를 받을 수 없어요.',
  '투명 음료 페트병을 제로 웨이스트 박스 가득 채워야 챌린지 성공!'
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(BoxMoving, { "challenge-type": 'campus' }),
    _createVNode(DividedBoxRow, { type: "campus" }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(HeadingBox, {
        title: 'Challenge Reward',
        type: 'rewards',
        subtitle: '보틀로 다시 태어나고 싶은 투명 음료병을 \n 도와준 나를 위한 특별한 선물',
        class: "d-none d-sm-block"
      }),
      _createVNode(HeadingBox, {
        title: 'Challenge Reward',
        type: 'rewards',
        subtitle: '',
        class: "d-sm-none"
      }),
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(colaItems, (item, index) => {
              return _createElementVNode("div", {
                key: index,
                class: "box-cola-item"
              }, [
                _hoisted_14,
                _createElementVNode("div", _hoisted_16, _toDisplayString(item), 1)
              ])
            }), 64))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _createVNode(ChallengeList, {
        "challenge-type": 'campus',
        challenges: __props.challenges,
        "hide-participate-button": participate.value,
        "show-additional-button": participate.value,
        onShowError: handleShowError
      }, null, 8, ["challenges", "hide-participate-button", "show-additional-button"])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createVNode(StepApplyCollection, {
          "heading-title": 'GS25 반값택배 이용 방법',
          "heading-type": 'challenge',
          "main-image": '',
          "main-image-height": 66,
          "main-title": '페트병을 모았다면, 이제 수거 신청만 하면 끝. <br>'+
          '누구나 쉽게 참여할 수 있는 제로 웨이스트 실천의 <br>'+
          '마지막 단계입니다',
          steps: stepApplySteps,
          "hover-color": '#f40000',
          "primary-color": '#f40000',
          "background-color": '#fff',
          "text-color": '#000'
        }, null, 8, ["main-title"])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createVNode(QuestionAnswerSs6, { tabs: questionTabs })
      ])
    ])
  ], 64))
}
}

})